import { ProductPricingModel } from '../enums/productPricingModel'
import { ProductType } from '../enums/productType'
import { Product } from '../types/product'

export const DEFAULT_PRODUCT: Product = {
  id: '',
  name: '',
  pricingModel: ProductPricingModel.Price,
  productType: ProductType.Goods,
  unit: '',
  vatPct: 0,
}
